export default "__VITE_ASSET__C4lxYby9__"